var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute rounded-xl bg-white shadow-lg p-2 w-max z-20",class:[_vm.positionUp ? 'bottom-full mb-2' : 'top-full mt-2'],attrs:{"id":"dropdown"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }